import BackButton from 'common/BackButton/BackButton';
import ErrorState from 'common/ErrorState/ErrorState';
import { useRevealGroup } from 'hooks/useReveal';
import { useContent } from 'hooks/useContent';
import NotFound from '../../../NotFound/NotFound';
import Loader from 'components/Loader/Loader';
import { useParams } from 'react-router-dom';
import Card from './Card/Card';
import './DocumentsSlider.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Документи розділу — ADR-0004, ADR-0005.
 *
 * Було: Swiper на всю висоту вікна з mousewheel-перехопленням, накладками на
 * кожен документ і правилом `.slider-box ~ .footer { display: none }`, яке
 * ховало підвал сайту на цій сторінці.
 * Стало: сітка документів. Кожен документ доступний з клавіатури і має пряме
 * посилання на PDF.
 *
 * Ім'я компонента збережено: воно згадане в маршруті /documents/:documentsType.
 */
export default function DocumentsSlider() {
  const language = useLanguage();
  const { data, status, error, retry, isLoading } = useContent('documents');
  const { documentsType } = useParams();
  const gridRef = useRevealGroup('.document-card', { step: 45 }, status);

  const { list: documents, types } = data;

  // Ідентифікатор у CMS — рядок, а не число: у Strapi 5 запис адресується
  // документним ідентифікатором. Тому й порівняння з тим, що стоїть в адресі,
  // рядкове.
  const filteredDocs = documents.filter((document) => document.documentType?.id === documentsType);
  const currentType = types.find(({ id }) => id === documentsType);
  const typeName = currentType ? currentType.name : '';

  // Розділ із неіснуючим номером у адресі — звичайна 404, а не порожній список.
  if (status === 'succeeded' && !currentType) return <NotFound />;

  return (
    <div className='slider-box section'>
      <div className='container'>
        <BackButton className='docs-back-btn' />

        <header className='documents-head'>
          <h1 className='page-title'>{typeName || (language === 'en' ? 'Documents' : 'Документи')}</h1>
          {filteredDocs.length > 0 && (
            <p className='documents-count tnum'>
              {filteredDocs.length} {language === 'en' ? 'documents' : 'документів'}
            </p>
          )}
        </header>

        {isLoading && <Loader />}

        {status === 'failed' && <ErrorState error={error} onRetry={retry} />}

        {status === 'succeeded' &&
          (filteredDocs.length > 0 ? (
            <div className='documents-grid' ref={gridRef}>
              {filteredDocs.map((document) => (
                <Card card={document} key={document.id} />
              ))}
            </div>
          ) : (
            <p className='empty-note'>
              {language === 'en' ? 'There are no documents in this section.' : 'У цьому розділі документів немає.'}
            </p>
          ))}
      </div>
    </div>
  );
}
